import { useSelector, useDispatch } from 'react-redux';
import bindActionCreators from 'Utilities/bindActionCreators';
import * as asyncActions from 'Store/actions/auth/asyncActions';

const useUser = () => {
  const { user, tenant, token } = useSelector(({ auth }) => auth);
  const dispatch = useDispatch();
  const { Signout } = bindActionCreators(asyncActions, dispatch);

  return { user, tenant, Signout, token };
};

export default useUser;
